export default __webpack_public_path__ + "static/media/settings.783520a6.png";